export default __webpack_public_path__ + "static/media/doctorLocator.47fd8af2.png";